import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import BasePopup from "@/components-UI/BasePopup.vue";
import BaseText from "@/components-UI/BaseText.vue";
import SvgArrowDown from "@/assets/icons/chevron.svg";

interface Props {
    activatorText: string;
    items: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DebtorsChipPopup',
  props: {
    activatorText: null,
    items: null
  },
  setup(__props: any) {

const props = __props as {
    activatorText: string;
    items: string[];
}


const isMenuOpen = ref<boolean>(false);

return { __sfc: true,props, isMenuOpen, BasePopup, BaseText, SvgArrowDown }
}

})